var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.as,_vm._g(_vm._b({tag:"component",staticClass:"AppButton",class:{
    'is-transparent border-black text-black': _vm.variant === 'transparent',
    'text-white bg-black': _vm.variant === 'default',
  },attrs:{"aria-label":_vm.ariaLabel}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }